import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import LocationList from './LocationList'
import LocationListCreate from './LocationListForms/LocationListCreate'
import LocationListEdit from './LocationListForms/LocationListEdit'

import { getChoicesCountries } from '../../../modules/actions/choices'
import { clearLocationLists, getLocationLists } from '../../../modules/actions/location'
import { choicesCountriesWasLoadedSelector } from '../../../modules/selectors/choices'
import { selectedPartnershipIdSelector } from '../../../modules/selectors/partnerships'

import useCommonStyles from '../../../styles/common/listPage'

function ManageLocationLists() {
  const commonClasses = useCommonStyles()

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const choicesCountriesWasLoaded = useSelector(choicesCountriesWasLoadedSelector)

  const selectedPartnershipId = useSelector(selectedPartnershipIdSelector)

  useEffect(() => {
    dispatch(getLocationLists({ limit: 10, partnership: selectedPartnershipId }))

    return () => {
      dispatch(clearLocationLists())
    }
  }, [dispatch, selectedPartnershipId])

  useEffect(() => {
    if (!choicesCountriesWasLoaded) {
      dispatch(getChoicesCountries())
    }
  }, [dispatch, choicesCountriesWasLoaded])

  return (
    <>
      <div className={commonClasses.heading}>
        <h3 className={commonClasses.title}>{t('Location Lists')}</h3>
        <p>
          {t(
            'Location lists are lists of addresses or postcodes that can be used to target ads. People who live near or were recently near a list of stores, for example, could be targeted.'
          )}
        </p>
        <div className={commonClasses.formButtons}>
          <LocationListCreate />
        </div>
      </div>
      <LocationList />
      <LocationListEdit />
    </>
  )
}

export default ManageLocationLists
